/**
 * CommandPreview - Preview panel for actionable commands
 */

import React from 'react';
import { CheckCircle, Loader2 } from 'lucide-react';
import { Pressable } from '../../common/motionSystem';

const CommandPreview = ({ preview, onConfirm, onCancel, loading }) => {
  if (!preview) return null;

  const { title, details, type, notice, canExecute = true } = preview;

  return (
    <div className="command-bar-preview">
      <div className="command-bar-preview-header">
        <CheckCircle size={16} color="#10B981" />
        <span className="command-bar-preview-label">Understood</span>
        <span className="command-bar-preview-title">{title}</span>
      </div>

      {details && (
        <div className="command-bar-preview-details">
          {details.recipients && (
            <div className="command-bar-preview-row">
              <span className="command-bar-preview-row-label">To:</span>
              <span className="command-bar-preview-row-value">
                {details.recipients} workers with overdue {details.training}
              </span>
            </div>
          )}
          {details.project && (
            <div className="command-bar-preview-row">
              <span className="command-bar-preview-row-label">Project:</span>
              <span className="command-bar-preview-row-value">
                {details.project}
              </span>
            </div>
          )}
          {details.message && (
            <div className="command-bar-preview-row">
              <span className="command-bar-preview-row-label">Message:</span>
              <span className="command-bar-preview-row-value">
                "{details.message.substring(0, 60)}..."
              </span>
            </div>
          )}
        </div>
      )}

      {notice && (
        <div className="command-bar-preview-notice">
          {notice}
        </div>
      )}

      <div className="command-bar-preview-actions">
        {type === 'action_preview' && (
          <Pressable
            as="button"
            className="command-bar-preview-btn secondary"
            onClick={() => {}}
            disabled={loading || !canExecute}
          >
            Edit Message
          </Pressable>
        )}
        <Pressable
          as="button"
          className="command-bar-preview-btn secondary"
          onClick={onCancel}
          disabled={loading}
        >
          Cancel
        </Pressable>
        <Pressable
          as="button"
          className="command-bar-preview-btn primary"
          onClick={() => onConfirm('execute')}
          disabled={loading || !canExecute}
        >
          {loading ? (
            <>
              <Loader2 size={14} className="spinning" style={{ marginRight: 6 }} />
              Sending...
            </>
          ) : (
            canExecute ? 'Send Now' : 'Unavailable'
          )}
        </Pressable>
      </div>
    </div>
  );
};

export default CommandPreview;
